<template>
  <div class="input-boolean-search-wrapper">
    <div class="input-ui">
      <div class="boolean-search-content">
        <div class="query-string">
          <template v-for="(element, i) in query">
            <div :key="i" class="element" @click="removeElement(element, i)">
              <span v-if="element.operator" class="operator" :class="{ 'operator': true, [toClassName(element.operator, element.negative)]: true }">{{$t(`articles.keyword.${element.operator.toLowerCase()}`)}}</span>
              <span v-if="element.negative" class="operator">{{$t("articles.keyword.not")}}</span>
              <span v-if="element.value" class="value">{{element.value}} <i class="fas fa-times remove"></i></span>
              
            </div>
          </template>
        </div>
        <div class="search-wrapper">
          <div ref="searchContent" class="search" contenteditable="true" @keydown="validateKeyPress" @keyup="updateSearch"></div>
          <span class="placeholder">{{$t("articles.keyword.search")}}</span>
        </div>
      </div>
    </div>
    <ul v-if="search" class="options">
      <li :key="getOptionKey(option, i)" v-for="(option, i) in availableOptions" @click="addToQuery(option)">
        <span class="type">{{getOptionTypeDisplay(option)}}</span>
        <span class="label">{{option.label}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    optionsType: String,
    onSearch: Function,
    options: Array,
    value: Array
  },

  data () {
    return {
      search: null,
      query: this.value || [],
      operators: {
        AND: "AND",
        OR: "OR",
        NOT: "NOT"
      }
    }
  },

  computed: {
    availableOptions () {
      const options = [];

      const nextInputs = this.nextInputType.filter(f => f !== "option");
      if (nextInputs.length > 0) {
        for (let i = 0; i < nextInputs.length; i++) {
          const input = nextInputs[i];
          const type = this.getOperatorType(input)
          options.push({
            value: input,
            label: input,
            type: type
          });
        }
      }
      
      if (this.nextInputType.indexOf("option") > -1 && this.options.length > 0) {
        Array.prototype.unshift.apply(options, this.options.map(opt => ({...opt, type: "option"})));
      }
      
      return options;
    },

    nextInputType () {
      const { query } = this;

      if (query.length === 0) {
        return ["option", this.operators.NOT];
      } else {
        const lastElement = query[query.length - 1];
        if (lastElement) {
          if (lastElement.value) {
            return [this.operators.AND, this.operators.OR];
          } else {
            if (lastElement.negative) {
              return ["option"];
            } else {
              return ["option", this.operators.NOT];
            }
          }
        } else {
          return ["option"];
        }
      }
    }
  },

  methods: {
    validateKeyPress (e) {
      if (e.keyCode === 13) { // Prevent line breaks.
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    },

    updateSearch (e) {
      const value = e.target.innerText;
      this.search = value;
    },

    resetSearch () {
      this.search = null;
      this.$refs.searchContent.innerText = "";
    },

    addToQuery (option) {
      const query = [...this.query];

      if (option.type === "operator") {
        query.push({
          operator: option.value
        })
      }

      if (option.type === "negative") {
        if (query.length === 0) {
          query.push({
            negative: true
          })
        } else {
          query[query.length - 1].negative = true;
        }
      }

      if (option.type === "option") {
        if (query.length > 0 && !query[query.length - 1].value) {
          query[query.length - 1].value = option.value;
        } else {
          query.push({
            value: option.value
          });
        }
      }

      this.query = query;
      this.resetSearch();
      this.$emit("onChange", query);
      this.$refs.searchContent.focus();
    },

    getOptionKey (option, index) {
      return index + "_" + option.value;
    },

    getOptionTypeDisplay (option) {
      if (this.optionsType && option.type === "option") {
        return this.optionsType;
      } else {
        return option.type;
      }
    },

    getOperatorType (operator) {
      switch (operator) {
        case this.operators.AND:
        case this.operators.OR:
        case this.operators.AND_NOT:
        case this.operators.OR_NOT:
          return "operator";
        case this.operators.NOT:
          return "negative";
      }
    },

    removeElement (element, index) {
      const query = [...this.query];
      if (query[index].value === element.value) {
        query.splice(index, 1);

        const firstElement = query[0];
        if (firstElement) {
          if (!firstElement.value) {
            query.splice(index, 1);
          } else if (firstElement.operator) {
            delete firstElement.operator;
          }
        }

        this.query = query;
        this.$emit("onChange", query);
      }
    },

    toClassName (value, negative) {
      return value.replaceAll(" ", "-").toLowerCase() + (negative ? "-not" : "");
    }
  },

  watch: {
    search: function (val) {
      if (this.onSearch && typeof this.onSearch === "function") {
        this.onSearch(val);
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/components/_input_boolean_search.scss";
</style>